import {AfterViewInit, Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import { CommonModule } from '@angular/common';
import {DxFileUploaderComponent, DxFileUploaderModule} from "devextreme-angular";
import {FormGroupDirective, FormsModule} from "@angular/forms";
import {MatGridListModule} from "@angular/material/grid-list";
import {PopupGenericComponent} from "../../dialogs/popup-generic/popup-generic.component";

@Component({
   selector: 'app-modal-upload-file',
   standalone: true,
   imports: [CommonModule, DxFileUploaderModule, FormsModule, MatGridListModule],
   templateUrl: './modal-upload-file.component.html',
   styleUrls: ['./modal-upload-file.component.scss']
})
export class ModalUploadFileComponent implements OnInit, AfterViewInit {
   @ViewChild("fileUploadImage") fileUploadImage!:DxFileUploaderComponent;
   @ViewChild("frmFileUploadImage") frmFileUploadImage!:FormGroupDirective;
   @ViewChild("dialogImages") dialogImages!:PopupGenericComponent;

   public fileLoaded: boolean = false;
   images: any[] = [];

   constructor() { }

   ngOnInit(): void {
   }

   ngAfterViewInit(): void {
     this.images = []
   }

   addImage($event: any) {
      if ($event.element.childElementCount > 0){
         this.fileLoaded = true
         var files = $event.value;
         if ($event.component.option("accept") === "image/*") {
            for (var i = 0; i < files.length; i++) {
               var file = files[i];
               this.previewImages(file);
            }
         }
      }
   }

   previewImages(file) {
      var reader = new FileReader();
      reader.onload = (theFile => {
         return  (e) => {
            this.images.push({'base':e.target?.result, 'file':file})
         };
      })(file);

      reader.readAsDataURL(file);
   }

   cancelImage(i: number) {
      this.images.splice(i, 1)
      this.fileUploadImage.value.splice(i,1)
   }


}
